import type { CaptureSharingSuggestion } from './types';

export function normalizeSharingSuggestions(value: unknown): CaptureSharingSuggestion[] {
  if (!Array.isArray(value)) return [];

  return value
    .map((entry) => {
      if (!entry || typeof entry !== 'object') return null;
      const row = entry as Record<string, unknown>;
      const id = typeof row.id === 'string' && row.id.trim().length > 0 ? row.id.trim() : '';
      const label = typeof row.label === 'string' ? row.label.trim() : '';
      const message = typeof row.message === 'string' ? row.message.trim() : '';
      const sentimentRaw = typeof row.sentiment === 'string' ? row.sentiment.trim().toUpperCase() : '';
      const sentiment = sentimentRaw === 'POSITIVE' || sentimentRaw === 'NEUTRAL' || sentimentRaw === 'NEGATIVE'
        ? sentimentRaw
        : 'NEUTRAL';
      if (!id || !label || !message) return null;
      return {
        id,
        label: label.slice(0, 24),
        message: message.slice(0, 280),
        sentiment,
      };
    })
    .filter((entry): entry is CaptureSharingSuggestion => entry !== null)
    .slice(0, 8);
}
